export const DEFAULT_LAT: number = 43.6031065;
export const DEFAULT_LONG: number = 1.4310325;




// WEBPACK FOOTER //
// ./src/app/constants.ts